import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.css'],
})
export class NoteModalComponent {
  @Input() checklistTextHeader: string;

  constructor(private activeModal: NgbActiveModal) {}

  saveClicked() {
    this.activeModal.close(this.checklistTextHeader);
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}
